import { action, props } from 'ts-action';
import { OptionalHistory, SkipHistory } from '../../undo/actions/undo.actions';
import { Wave } from '../../wave/types/wave.type';
import { Delineation, DelineationId } from '../types/delineation.type';

export const load = action(
  '[Delineation] load',
  props<{ delineations: Delineation[] } & SkipHistory>(),
);

export const select = action(
  '[Delineation] select',
  props<
    {
      delineationId: DelineationId;
    } & OptionalHistory
  >(),
);

export const addDelineation = action(
  '[Delineation] addDelineation',
  props<{ delineation: Delineation }>(),
);

export const setWaves = action(
  '[Delineation] setWaves',
  props<{ delineationId: DelineationId; waves: Wave[] } & SkipHistory>(),
);

export const markAsSaved = action('[Delineation] markAsSaved');
